



















import { surveySessionsPreviewList } from '@/+state/survey-sessions/projections';
import BlueCard from '@/shared/components/BlueCard.vue';
import EmptyState from '@/shared/components/EmptyState.vue';
import { select } from '@conversa/reflex';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: { EmptyState, BlueCard },
  setup() {
    return {
      data: select(surveySessionsPreviewList),
    };
  },
});
